export default "__VITE_ASSET__BP2aS76S__"